/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const UberIconConfig = {
  name: 'UberIcon',
  height: 512,
  width: 448,
  svgPath: 'M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(UberIconConfig);
//# sourceMappingURL=uber-icon.js.map